{
  "loading": "Notiek ielāde...",
  "placeholder": "Izvēlēties…"
}
